module.exports = __webpack_public_path__ + "static/media/souq.f1770f91.png";